<template>
    <section class="step-2" v-if="localAvailableCabins.length">

        <ul class="ariane">
            <li class="item">{{ roomLabelCap }} {{ cabinIndex + 1 }}</li>
            <li class="item active">Choix {{ roomLabel }}</li>
        </ul>

        <form @submit.prevent="nextStep()">
            <div class="vignettes-cabines">

                <!-- grid manuelle -->
                <article v-for="cabin in localAvailableCabins"
                         class="cabine"
                         :class="{active: cabin.index === selectedCabin.index}"
                         @click="selectCabin(cabin)">
                    <span class="nom-cabine">{{ cabin.type.label }}</span>
                    <span class="surfix">à partir de</span>
                    <span class="prix">
                    {{ cabin.price | currency }}
                </span>
                    <span>/pers</span>
                    <span class="stock" :class="cabinStockClasses(cabin)">
                    {{ cabinStockLabel(cabin) }}
                </span>
                </article>
            </div>

            <div class="vignettes-cabines">

                <div class="infos-box"
                     v-show="selectedCabin.type.book_all && selectedCabin.type.size === 2 && selectedCabin.seat_left >= 2">
                    En choisissant cette {{ roomLabel }}, vous avez la possibilité de voyager seul en bloquant le second
                    lit
                    <template v-if="selectedCabin.type.shareable">ou de spécifier le nombre de places</template>
                    .
                </div>


                <div class="infos-box error"
                     v-show="selectedCabin.type.size > 1 && selectedCabin.seat_left > 0 && selectedCabin.seat_left < selectedCabin.type.size">
                    ATTENTION ! <br>Cette {{ roomLabel }} est partagée et ne dispose plus que de <strong>{{selectedCabin.seat_left}}
                    lit
                    <template v-if="selectedCabin.seat_left > 1">s</template>
                    .</strong>
                    <template v-if="selectedCabin.type.size === 2">Vous ne pourrez pas la réserver en entier.</template>
                </div>

                <div class="infos-box error" v-show="selectedCabin.seat_left === 0">
                    Cette {{ roomLabel }} n'est plus disponible
                </div>

            </div>


            <div class="details-cabine">

                <div class="prix-choix">
                    <p>{{ selectedCabin.type.label }}</p>
                    <p class="nbr-voyageurs">
                        <img :src="`/app/themes/grands-espaces/assets/images/page-produit/travelers/traveler_${(size % 4) || 4}.svg`"
                             class="picto1v"
                             v-for="size in selectedCabin.type.size">
                        {{ selectedCabin.type.size }} voyageur{{ selectedCabin.type.size > 1 ? 's' : '' }}
                    </p>
                    <p class="prix fleche rouge">
                        {{ selectedCabin.price | currency }}<sup>*</sup>
                        <span>/pers</span>
                    </p>

                    <p v-if="selectedCabin.type.book_all && selectedCabin.type.size === 2 && selectedCabin.seat_left >= 2">
                        <input type="checkbox"
                               id="alone-cabin"
                               name="share-cabin"
                               class="ge"
                               v-model="selectedCabin.book_all">
                        <label for="alone-cabin">
                            Je souhaite être seul à bord dans cette cabine
                            <template v-if="selectedCabin.type.size === 2">(x1.8 du prix)</template>
                        </label>
                    </p>

                    <p v-if="showSeatsInput">
                        <floating-label label="Nombre de places à réserver *">
                            <input type="number" v-model.number="selectedCabin.seats" min="1" step="1"
                                   :max="selectedCabinMaxSeatBookable">
                        </floating-label>
                    </p>

                    <p class="description" v-html="selectedCabin.type.description"></p>
                </div>

                <div class="photos">
                    <a :href="photo.url"
                       data-fancybox="gallery"
                       v-for="(photo, index) in selectedCabin.type.photos"
                       :class="{ hide: index >= 2 }"
                       v-if="index !== 2">
                        <img :src="photo.url" :alt="photo.alt">
                    </a>
                    <a v-if="selectedCabin.type.photos[2]" :href="selectedCabin.type.photos[2].url"
                       data-fancybox="gallery" class="lien-next">Plus de photos</a>

                </div>
                <div class="photosMobile">
                    <a v-if="selectedCabin.type.photos[0]" :href="selectedCabin.type.photos[0].url"
                       data-fancybox="galleryMobile" class="lien-next mobile">Photos de la cabine</a>
                    <a :href="photo.url"
                       data-fancybox="galleryMobile"
                       v-for="(photo, index) in selectedCabin.type.photos"
                       :class="{ hide: index < 0 }"
                       v-if="index > 0"></a>
                </div>

                <div class="details">

                    <p>Détails</p>

                    <div class="detail" v-if="selectedCabin.type.area">
                        <div class="canvas">
                            <img src="/app/themes/grands-espaces/dist/images/page-produit/cp_superficie.svg"
                                 alt="" class="superficie">
                        </div>
                        <div>
                            <p>Superficie</p>
                            <p>{{ selectedCabin.type.area }} m<sup>2</sup></p>
                        </div>
                    </div>

                    <div class="detail" v-if="selectedCabin.type.windows">
                        <div class="canvas">
                            <img src="/app/themes/grands-espaces/dist/images/page-produit/cp_fenetre.svg" alt=""
                                 class="fenetre">
                        </div>
                        <div>
                            <p>Fenêtre</p>
                            <p>{{ selectedCabin.type.windows }}</p>
                        </div>
                    </div>

                    <div class="detail" v-if="selectedCabin.type.beds">
                        <div class="canvas">
                            <img src="/app/themes/grands-espaces/dist/images/page-produit/cp_couchage.svg" alt=""
                                 class="couchages">
                        </div>
                        <div>
                            <p>Couchages</p>
                            <p>{{ selectedCabin.type.beds }}</p>
                        </div>
                    </div>

                    <div class="detail" v-if="selectedCabin.type.amenities">
                        <div class="canvas">
                            <img src="/app/themes/grands-espaces/dist/images/page-produit/cp_accomodation.svg"
                                 alt="">
                        </div>
                        <div>
                            <p>Accomodation</p>
                            <p>{{ selectedCabin.type.amenities }}</p>
                        </div>
                    </div>

                    <div class="detail" v-if="selectedCabin.type.equipment">
                        <div class="canvas">
                            <img src="/app/themes/grands-espaces/dist/images/page-produit/cp_equipement.svg"
                                 alt="" class="equipements">
                        </div>
                        <div>
                            <p>Équipements</p>
                            <p>{{ selectedCabin.type.equipment }}</p>
                        </div>
                    </div>


                </div>

            </div>
            <div class="recap-tarif">
                <span>Total</span>
                <p>{{ selectedCabin.type.label }}</p>
                <div class="cta-prix">
                    <p class="prix rouge">{{ selectedCabinPrice | currency }}</p>
                    <button type="submit" class="btn chevron" :disabled="isNextStepOk(selectedCabin)">
                        Choisir cette {{ roomLabel }} et continuer
                    </button>
                </div>

            </div>
        </form>

    </section>
</template>

<script>
    import {cloneDeep, forEach} from 'lodash';

    export default {
        props: {
            availableCabins: {
                type: Array,
                required: true,
            },
            form: {
                type: Array,
                required: true,
            },
            cabinIndex: {
                type: Number,
                required: true,
            },
            isCircuit: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                localAvailableCabins: null,
                selectedCabin: null,
            };
        },
        watch: {
            bookAll($new, $old) {
                if ($new) {
                    this.selectedCabin.seats = 1;
                } else {
                    if (this.selectedCabin.type.shareable === true) {
                        this.selectedCabin.seats = 1;
                    } else {
                        this.selectedCabin.seats = this.selectedCabin.type.size;
                    }
                }
            }
        },
        computed: {
            selectedCabinPrice() {
                // let priceMultiplier = this.selectedCabin.type.book_all && !this.selectedCabin.share ?
                //     (this.selectedCabin.type.size - this.selectedCabin.type.size * 0.1) :
                //     this.selectedCabin.type.size;

                if (this.selectedCabin.book_all === true && this.selectedCabin.type.size === 2) {
                    return this.selectedCabin.price * 1.8;
                }

                return this.selectedCabin.price * this.selectedCabin.seats;
            },
            showSeatsInput() {
                return (this.selectedCabin.type.shareable && !this.selectedCabin.book_all && this.selectedCabin.type.size >= 2 && this.selectedCabin.seat_left > 1) || (this.selectedCabin.seat_left < this.selectedCabin.type.size && this.selectedCabin.seat_left > 1);
            },
            isMobile() {
                return this.$root.isMobile;
            },
            roomLabelCap() {
                return this.isCircuit ? 'Chambre' : 'Cabine';
            },
            roomLabel() {
                return this.isCircuit ? 'chambre' : 'cabine';
            },
            selectedCabinMaxSeatBookable() {
                if (this.selectedCabin.seat_left < this.selectedCabin.type.size) {
                    return this.selectedCabin.seat_left;
                } else {
                    return this.selectedCabin.type.size;
                }
            },
            bookAll() {
                if (this.selectedCabin === null) {
                    return false;
                } else {
                    return this.selectedCabin.book_all;
                }
            }
        },
        methods: {
            isNextStepOk(selectedCabin) {
                if (selectedCabin.seat_left === 1 && selectedCabin.seats === 1) return false
                if (selectedCabin.seat_left === 0 ||
                    (selectedCabin.seat_left < 2 && selectedCabin.type.shareable === false)) {
                    return true;
                } else {
                    return false;
                }

            },
            cabinStockClasses(cabin) {
                if (cabin.seat_left === 1 && cabin.seats === 1) return 'dernier';
                if (cabin.seat_left < 2 && cabin.type.shareable === false) return 'complet';
                if (cabin.seat_left === 0) return 'complet';
                if (cabin.seat_left <= 2) return 'dernier';
                return 'disponible';
            },
            cabinStockLabel(cabin) {
                if (cabin.seat_left === 1 && cabin.seats === 1) return 'Dernière place !';
                if (cabin.seat_left < 2 && cabin.type.shareable === false) {
                    return 'complet';
                }
                if (cabin.seat_left === 0) {
                    return 'Complet';
                }
                if (cabin.seat_left <= 2) {
                    return 'Dernières places !';
                }
                return 'Disponible';
            },
            selectCabin(cabin) {
                this.selectedCabin = cloneDeep(cabin);

                // Maj Stock Cabine déjà choisies


                if (this.selectedCabin.type.shareable === false && this.selectedCabin.seat_left >= this.selectedCabin.type.size) {
                    this.selectedCabin.seats = this.selectedCabin.type.size;
                } else if (this.selectedCabin.type.shareable === false && this.selectedCabin.seat_left < this.selectedCabin.type.size) {
                    this.selectedCabin.seats = this.selectedCabin.seat_left;
                }

            },
            nextStep() {
                this.$emit('selected', this.selectedCabin);
            },
            initStock() {

                this.localAvailableCabins = cloneDeep(this.availableCabins);

                if (this.form.length >= 1) {

                    forEach(this.form, (cabin) => {

                        forEach(this.localAvailableCabins, (availableCabin, index) => {

                            if (availableCabin.index === cabin.index) {

                                this.localAvailableCabins[index].seat_left -= cabin.seats;
                            }

                        });

                    });
                }


            }
        },
        created() {
            this.initStock();

            this.selectCabin(this.localAvailableCabins[0]);

        },
        activated() {
            this.initStock();
            this.$emit('clean-travelers');

        }
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/cruise-configurator/CabinSelect.vue